import { render, staticRenderFns } from "./PageReservation.vue?vue&type=template&id=6f74cce4&"
import script from "./PageReservation.vue?vue&type=script&lang=js&"
export * from "./PageReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f74cce4')) {
      api.createRecord('6f74cce4', component.options)
    } else {
      api.reload('6f74cce4', component.options)
    }
    module.hot.accept("./PageReservation.vue?vue&type=template&id=6f74cce4&", function () {
      api.rerender('6f74cce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageReservation.vue"
export default component.exports